module.exports = __webpack_public_path__ + "img/vd-cupids-arrow.eb036dfc.svg";